import styled from "styled-components";
import { Card } from "antd";

export const StyledCard = styled(Card)`
  margin: 0;
  margin-top: 2em;
  border-radius: 0.2em;
`;

export const StyledTitleDiv = styled.div`
  position: relative;
  width: 100%;
  font-wight: bolder;
  font-size: 1.5em;
  margin-bottom: 1em;
`;

export const StyledWrapper = styled.div`
  max-width: 2000px;
  height: 100%;
`;

export const StyledTextDivBold = styled.div`
  text-align: left;
  font-weight: bold;
`;

export const StyledTextDiv = styled.div`
  text-align: left;
  margin-bottom: 1em;
`;
